import React from 'react'
import stylesC from '../../styles/common.module.css';

interface ServiceCasesProps {
    title: string,
    titleEng: string,
}

const ServiceCases: React.FC<ServiceCasesProps> = ({ title, titleEng }) => {
    return (
        <div className={`${stylesC.titleS} ${stylesC.titleService}`}>
            <h2>
                {title}
            </h2>
            <span className={stylesC.content}>
                {titleEng}
            </span>
        </div>
    );
}

export default ServiceCases;